import * as React from "react";
import { Elements } from "@stripe/react-stripe-js";
import "whatwg-fetch";
import PaymentForm from "./PaymentForm";
import StripeError from "../commons/model/pricing/StripeError";
import { BilledInterval } from "../commons/model/pricing/BilledInterval";
import TaxRate from "../commons/model/pricing/TaxRate";
import { FormBackLinkProps } from "../commons/components/form/FormBackLink";
import LegalConsentProps from "../legal/LegalConsentProps";
import InputState from "../commons/model/form/InputState";
import Country from "../commons/model/address/Country";
import { loadStripe } from "@stripe/stripe-js";

interface PaymentFormWrapperProps extends LegalConsentProps {
  stripePublishableApiKey: string;
  stripePlanId: string;
  priceExcludingTaxInCents: number;
  currency: string;
  billedInterval: BilledInterval;
  taxRate?: TaxRate;
  trialPeriodDay: number;
  country: Country;
  validateEndpoint: string;
  submitLabel: string;
  onSubmitSucceeded: (payload: any, form: { [key: string]: InputState }) => void;
  errorMsg?: string;
  stripeError?: StripeError;
  contactUsEmail: any;
  backLink: FormBackLinkProps;
}

const PaymentFormWrapper: React.FC<React.PropsWithChildren<PaymentFormWrapperProps>> = (
  props: PaymentFormWrapperProps
) => {
  const stripePromise = loadStripe(props.stripePublishableApiKey);

  return (
    <Elements stripe={stripePromise}>
      {/* TODO blaborde 18/10/2019 this should localize the Stripe error messages but apparently not... */}
      <PaymentForm {...props} />
    </Elements>
  );
};

export default PaymentFormWrapper;
